import type { Region } from '../utils/geometry';

export interface WaterFeatureDef {
  id: string;
  region: Region;
  /** World-space Y height of the water plane. */
  waterLevel: number;
  kind?: 'pond' | 'lake' | 'stream';
}

/**
 * Pure data, same split as VegetationField/VegetationRenderer: WaterFeature
 * owns the hazard's definition (region, water level, kind), nothing about
 * Three.js meshes. See rendering/WaterRenderer.ts for how this becomes an
 * actual mesh. Keeping rendering out of this class means gameplay code
 * (ball-in-water detection, penalty rules) can depend on WaterFeatureDef
 * well before — or independent of — however the visual is implemented.
 */
export class WaterFeature {
  constructor(readonly def: WaterFeatureDef) {}
}
